import { ActionReducerMap, createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromMPReducer from '@appStore/metering-points/reducers/metering-point.reducer';
import * as fromMPGReducer from '@appStore/metering-points/reducers/metering-point-group.reducer';
import * as fromMPVGReducer from '@appStore/metering-points/reducers/metering-point-virtual-group.reducer';
import * as fromAgreements from '@appStore/metering-points/reducers/agreement.reducer';
import * as fromRoot from '../../../reducers';
import { MeteringPointTabType } from '@enums';
import { from } from 'rxjs';

// feature state
export interface MeteringPointsState {
  meteringPoints: fromMPReducer.State;
  meteringPointGroups: fromMPGReducer.State;
  virtualGroup: fromMPVGReducer.State;
  agreements: fromAgreements.State;
}

export interface State extends fromRoot.State {
  meteringPoints: MeteringPointsState;
}

// reducers
export const reducers: ActionReducerMap<MeteringPointsState> = {
  meteringPoints: fromMPReducer.reducer,
  meteringPointGroups: fromMPGReducer.reducer,
  virtualGroup: fromMPVGReducer.reducer,
  agreements: fromAgreements.reducer,
};

export const getState = createFeatureSelector<MeteringPointsState>('meteringpoints');

// MeteringPoints
export const getMeteringPointsState = createSelector(
  getState,
  state => state.meteringPoints
);

export const getMeteringPoints = createSelector(
  getMeteringPointsState,
  fromMPReducer.getAllMeteringPoints
);

export const getMeteringPointsAndLoaded = createSelector(
  getMeteringPointsState,
  fromMPReducer.getAllMeteringPointsAndLoaded
);

export const getMeteringPointsLoading = createSelector(
  getMeteringPointsState,
  fromMPReducer.getMeteringPointsLoading
);

export const getMeteringPointsLoaded = createSelector(
  getMeteringPointsState,
  fromMPReducer.getMeteringPointsLoaded
);

export const getMeteringPointsWithAdresses = createSelector(
  getMeteringPoints,
  meteringPoints => {
    return meteringPoints.map(mp => {
      var littra = '';
      if (mp.addresses && mp.addresses.length > 0) {
        littra = mp.addresses[0].littra ? mp.addresses[0].littra : '';
      }
      return {
        ...mp,
        addressLabel:
          !mp.addresses || mp.addresses.length === 0
            ? '(Ingen Adress)'
            : mp.addresses[0].street + ' ' + mp.addresses[0].streetNo + littra
      };
    });
  }
);

export const getMeteringPointDisruptionsLoaded = createSelector(
  getMeteringPointsState,
  fromMPReducer.getMeteringPointDisruptionsLoaded
);

export const getMeteringPointsWithDisruptions = createSelector(
  getMeteringPoints,
  meteringPoints => {
    return meteringPoints.filter(mp => mp.disruptionInfos);
  }
);

export const getMeteringPointHasIntelligy = (meteringPointId: number) => createSelector(
  getMeteringPointsState,
  fromMPReducer.getMeteringPointHasIntelligy(meteringPointId)
);

export const getIsAnyMeteringPointUsingIntelligy = createSelector(
  getMeteringPointsState,
  fromMPReducer.getIsAnyMeteringPointUsingIntelligy
)

// FilterSettings
export const getMeteringPointSettings = createSelector(
  getMeteringPointsState,
  fromMPReducer.getMeteringPointSettings
);

// Climate Compensated CO2
export const getClimateCompensatedCO2 = createSelector(
  getMeteringPointsState,
  fromMPReducer.getClimateCompensatedData
);
export const getClimateCompensatedCO2Loaded = createSelector(
  getMeteringPointsState,
  fromMPReducer.getClimateCompensatedDataLoaded
);

// MeteringPointGroups
export const getMeteringPointGroupsState = createSelector(
  getState,
  state => state.meteringPointGroups
);
export const getMeteringPointGroups = createSelector(
  getMeteringPointGroupsState,
  fromMPGReducer.getAllMeteringPointGroups
);
export const getMeteringPointGroupsLoading = createSelector(
  getMeteringPointGroupsState,
  fromMPGReducer.getMeteringPointGroupsLoading
);
export const getMeteringPointGroupsLoaded = createSelector(
  getMeteringPointGroupsState,
  fromMPGReducer.getMeteringPointGroupsLoaded
);
export const getAddMeteringPointGroupSuccess = createSelector(
  getMeteringPointGroupsState,
  fromMPGReducer.getAddMeteringPointGroupSuccess
);
export const getAddedMeteringPointGroup = createSelector(
  getMeteringPointGroupsState,
  fromMPGReducer.getAddedMeteringPointGroup
);

// REPORT KEY
export const getReportKey = createSelector(
  getState,
  (state: MeteringPointsState) => state.meteringPoints.key
);

// Function controls
export const getMeteringPointFunctionControls = createSelector(
  getMeteringPointsState,
  fromMPReducer.getMeteringPointsFunctionControl
);

export const getSelectedMeteringPoint = createSelector(
  getMeteringPointsState,
  fromMPReducer.getSelectedMeteringPoint
);

export const getSelectedMeteringPointTabIndex = createSelector(
  getMeteringPointsState,
  state => {
    switch (state.selectedMeteringPointTabIndex) {
      case MeteringPointTabType.Details:
        return 0;
      case MeteringPointTabType.Metering:
        return 1;
      case MeteringPointTabType.Logical:
        return 2;
      case MeteringPointTabType.FunctionalControl:
        return 3;
    }
  }
);


export const getSelectedMeteringPointsTabIndex = createSelector(
  getMeteringPointsState,
  fromMPReducer.getSelectedMeteringPointsTabIndex
);
export const getSelectedHotMeteringPointsPageIndex = createSelector(
  getMeteringPointsState,
  fromMPReducer.getSelectedPagingPropertiesHot
);
export const getSelectedColdMeteringPointsPageIndex = createSelector(
  getMeteringPointsState,
  fromMPReducer.getSelectedPagingPropertiesCold
);

// Virtual Group
export const getVirtualGroupState = createSelector(
  getState,
  state => state.virtualGroup
);
export const getVirtualGroup = createSelector(
  getVirtualGroupState,
  fromMPVGReducer.getVirtualGroup
);

// Agreements
export const getAgreementState = createSelector(
  getState,
  (state: MeteringPointsState) => state.agreements
);

export const getTaxReturnAgreementCreated = createSelector(
  getAgreementState,
  fromAgreements.getTaxReturnAgreementCreated
);

export const getTaxReturnAgreementCreatedId = createSelector(
  getAgreementState,
  fromAgreements.getTaxReturnAgreementCreateId
);

export const getActiveAgreementLinkLoaded = createSelector(
  getAgreementState,
  fromAgreements.getActiveAgreementLinkLoaded
);

export const getActiveAgreementLink = createSelector(
  getAgreementState,
  fromAgreements.getActiveAgreementLink
);



